import { useParams } from "react-router";
import { CMSContext, CMSContextInitialValues } from "./CMSContext";
import { useGetPuckPage } from "src/api/client-api/cms/useGetPuckPage";
import { Loading } from "src/components/utils/Loading";

type CMSProviderProps = {
    children: React.ReactNode;
};

export const CMSProvider = (props: CMSProviderProps) => {
    const { children } = props;
    const { slug } = useParams();

    const { page, isFetched: puckFetched } = useGetPuckPage({
        slug: slug || "",
    });

    if (!puckFetched) {
        return <Loading />;
    }

    const items: CMSContextInitialValues = {
        CMSPage: page,
        isContentFetched: puckFetched,
    };

    return <CMSContext.Provider value={items}>{children}</CMSContext.Provider>;
};
